import { buildRoute } from '@direct-frontend/modules-router';

export const abcAnalysisRoute = buildRoute('/abc-analysis');
